import {useCallback} from 'react';

export const useFormKeyHandler = () => {
  const handleFormKeyDown = useCallback((e: React.KeyboardEvent) => {
    // 엔터키 눌렀을 때 form submit 방지
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }, []);

  return {handleFormKeyDown};
};
